import React from 'react'
import { keys } from 'ramda'
import classNames from 'classnames'

import { SeasonTagType } from '../prop-types'
import { EpisodeSelectorUiConsumer } from '../episode-selector-ui'
import {
  getResponsiveSeasonShowCount
} from '../../../../../lib/utils'
import EmblaCarousel from '../../../../emblaCarousel'
import { useScreenWidth } from '../../../../../hooks/use-screen-width'
import styles from './tabs.css'

function Tabs({ seasonTag }) {
  const seasonNumbers = keys(seasonTag)
  const screenWidth = useScreenWidth()
  const slidesToShow = getResponsiveSeasonShowCount(screenWidth, 1)
  return (
    <EpisodeSelectorUiConsumer>
      {({
        currentSeason,
        activeSeason,
        setActiveSeason,
        episodeCount,
        loadedImagery
      }) => {
        const currentSeasonIndex = seasonNumbers.findIndex(season => season === currentSeason)

        return (
          <EmblaCarousel
            startSlideIndex={currentSeasonIndex}
            slidesToShow={slidesToShow}
            activeSlideCount={seasonNumbers.length}
          >
            {seasonNumbers.map(season => (
              <div
                key={season}
                className={classNames(
                  styles.emblaSlide,
                  {
                    [styles.textActive]: activeSeason === season
                  }
                )}
                role="button"
                tabIndex={0}
                onClick={() => setActiveSeason(season)}
                onKeyDown={(event) => {
                  if (event.key === 'Enter' || event.key === ' ') {
                    setActiveSeason(season)
                  }
                }}
              >
                {seasonTag[season]}
              </div>
            ))}
          </EmblaCarousel>
        )
      }}
    </EpisodeSelectorUiConsumer>
  )
}

Tabs.propTypes = {
  seasonTag: SeasonTagType.isRequired
}

export default Tabs
